export class OrganizationCreateModel{
  name!: string;
}
